import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { TextField } from '@rmwc/textfield';
import { Button } from '@rmwc/button';

const Form = styled.form`
  display: flex;
  flex-direction: column;
`;

const Feedback = styled.div`
  margin: 20px 0;
  text-align: center;
  font-weight: ${props => props.theme.fontWeights.medium};
  color: ${props => props.theme.colors.error};
`;

const Field = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 0;
`;

const SubmitButton = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 30px;
  padding: 10px 0;
`;

const FormForgot = props => {
  const { onSubmit, feedback } = props;

  const handleSubmit = useCallback(
    event => {
      event.preventDefault();
      const { username } = event.target.elements;
      const data = { username: username.value };
      onSubmit(data);
    },
    [onSubmit],
  );

  return (
    <Form onSubmit={handleSubmit}>
      <Feedback>{feedback}</Feedback>
      <Field>
        <TextField
          required
          type="text"
          name="username"
          label="Usuario"
          placeholder="usuario@empresa"
        />
      </Field>
      <SubmitButton>
        <Button label="Solicitar" raised />
      </SubmitButton>
    </Form>
  );
};

FormForgot.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  feedback: PropTypes.string,
};

FormForgot.defaultProps = {
  feedback: '',
};

export default FormForgot;
